/**
 * Navigation state storage.
 * Used as a shared bus between components and the useRedirectBack hook.
 */
export const navigationState = {
  /**
   * Flag indicating that the back navigation was triggered programmatically (via code)
   * rather than by the user clicking the browser's back button.
   */
  isInternal: false,
};

/**
 * Executes a back navigation that bypasses the global redirect/trap logic.
 * Use this instead of navigate(-1) for internal app transitions.
 * * @param navigateFn — The navigate function from the useNavigate() hook
 */
export const internalNavigateBack = (navigateFn: (n: number) => void) => {
  navigationState.isInternal = true;
  navigateFn(-1);
};
